export class EnvParams {
    private readonly validFrom: string;
    private readonly validTo: string;
    public slots: string | string[];
    private readonly requestedChanges: [] | string;
    private readonly dataType: string;

    constructor(
        validFrom: string,
        validTo: string,
        slots: string | string[],
        requestedChanges: [] | string,
        dataType: string
    ) {
        this.validFrom = validFrom;
        this.validTo = validTo;
        this.slots = slots;
        this.requestedChanges = requestedChanges;
        this.dataType = dataType;
    }

    toRequestParams = () => {
        return `VALID_FROM:'${this.validFrom}';VALID_TO:'${this.validTo ?? ""}';SLOTS:'${
            this.slots
        }';REQUESTED_CHANGES:'${this.requestedChanges}';DATA_TYPE:'${this.dataType ?? ""}'`;
    };
}
